/**
 * Progress bar for My Projects cards.
 * Variant: accent (published), moderation (pending), draft (gray).
 */
interface ProjectProgressBarProps {
  percent: number;
  variant: 'accent' | 'moderation' | 'draft';
}

export function ProjectProgressBar({ percent, variant }: ProjectProgressBarProps) {
  const style: React.CSSProperties = {
    height: 3,
    background: 'rgba(255,255,255,0.07)',
    borderRadius: 2,
    marginBottom: 8,
    overflow: 'hidden',
  };
  const fillStyle: React.CSSProperties = {
    height: '100%',
    width: `${Math.min(100, Math.max(0, percent))}%`,
    borderRadius: 2,
    transition: 'width 0.4s',
  };
  if (variant === 'accent') {
    fillStyle.background = 'linear-gradient(90deg, #7850ff, #c084fc)';
  } else if (variant === 'moderation') {
    fillStyle.background = 'linear-gradient(90deg, #fbbf24, #f59e0b)';
  } else {
    fillStyle.background = 'rgba(255,255,255,0.2)';
  }

  return (
    <div style={style}>
      <div style={fillStyle} />
    </div>
  );
}
